"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getDefaultParams_1 = require("../helpers/getDefaultParams");
var ky_imlpConfig_1 = require("../config/ky.imlpConfig");
var service_status_enum_1 = require("../enums/service-status.enum");
var PathwayService = {
    standardPathway: function (studentId, studentPathwayId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.get)("".concat(params.pathwayNavigatorUrl, "students/").concat(studentId, "/student-pathways/").concat(studentPathwayId))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatPathwayResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatPathwayResponse(service_status_enum_1.default.ERROR, error); });
    },
    createPathway: function (createRequest, studentId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.post)("".concat(params.pathwayNavigatorUrl, "students/").concat(studentId, "/student-pathways/create"), { json: createRequest })
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatPathwayResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatPathwayResponse(service_status_enum_1.default.ERROR, error); });
    },
    searchPathway: function (searchRequest, studentId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.post)("".concat(params.pathwayNavigatorUrl, "students/").concat(studentId, "/student-pathways/search"), { json: searchRequest })
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatPathwayResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatPathwayResponse(service_status_enum_1.default.ERROR, error); });
    },
    currentActivity: function (studentId, studentPathwayId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.post)("".concat(params.pathwayNavigatorUrl, "students/").concat(studentId, "/student-pathways/").concat(studentPathwayId, "/current-activity"))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatPathwayResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatPathwayResponse(service_status_enum_1.default.ERROR, error); });
    },
    currentActivityStart: function (startActivityRequest, studentId, studentPathwayId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.post)("".concat(params.pathwayNavigatorUrl, "students/").concat(studentId, "/student-pathways/").concat(studentPathwayId, "/current-activity/start"), { json: startActivityRequest })
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatPathwayResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatPathwayResponse(service_status_enum_1.default.ERROR, error); });
    },
    currentActivityComplete: function (studentId, studentPathwayId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.post)("".concat(params.pathwayNavigatorUrl, "students/").concat(studentId, "/student-pathways/").concat(studentPathwayId, "/current-activity/complete"))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatPathwayResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatPathwayResponse(service_status_enum_1.default.ERROR, error); });
    },
    currentLessonScore: function (studentId, lessonAttemptId) {
        var params = (0, getDefaultParams_1.getDefaultParams)();
        return (0, ky_imlpConfig_1.get)("".concat(params.pathwayNavigatorUrl, "students/").concat(studentId, "/lesson-attempts/").concat(lessonAttemptId, "/score"))
            .then(function (response) { return response.json(); })
            .then(function (response) { return formatPathwayResponse(service_status_enum_1.default.LOADED, response); })
            .catch(function (error) { return formatPathwayResponse(service_status_enum_1.default.ERROR, error); });
    }
};
exports.default = PathwayService;
var formatPathwayResponse = function (status, response) { return ({
    status: status,
    response: response
}); };
